import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import Badge from 'components/Badge/Badge';
import { Link } from 'react-router-dom';

import { Create, Add, BeenhereRounded, Visibility } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { wsGet, wsGetAll } from 'services/WService.js';

import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { useParams } from 'react-router-dom';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};

const useStyles = makeStyles(styles);
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Línea', accessor: 'line' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];
export default WithApp(function Family(props) {
  const { lineId } = useParams();

  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();

  const [category, setCategory] = useState();
  const [line, setLine] = useState();
  const [families, setFamilies] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadFamilies() {
    setDataLoading(true);
    let response = await wsGetAll('logi/family');
    setDataLoading(false);
    if (response.success) setFamilies(response.data);
  }

  async function loadLine() {
    setDataLoading(true);
    let response = await wsGet('logi/line', lineId);
    setDataLoading(false);
    if(!response.success) return;
    let { category, families, ...line } = response.data;

    setCategory(category);
    setLine(line);
    setFamilies(families);
  }

  useEffect(() => {
    if(lineId === undefined){
      loadFamilies();
    }else{
      loadLine();
    }
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadFamilies} />

      <GridItem xs={12}>
        <Card>
          {lineId === undefined ? (
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.LOGI_FAMILIES_STORE}
                component={
                  <CardIcon color="primary">
                    <BeenhereRounded style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <CardIcon
                  onClick={() => setOpen({})}
                  pointer="true"
                  color={props.themeContext.buttonColorSuccess}
                >
                  <Add />
                </CardIcon>
              </AllowedGuard>
              <h4 className={classes.cardIconTitle}>Listado de Familias {dataLoading && <LoadingSpinner />}</h4>
            </CardHeader>
          ) : (
            <CardHeader>
              {line !== undefined ? (
                <Fragment>
                  <Badge color="info">{category?.business_partner.CardName}</Badge>
                  <Badge color="primary">Categoria {category?.description}</Badge>
                </Fragment>
              ) : undefined}
              <h3 className={classes.cardIconTitle}>
                {line === undefined ? 'Cargando línea...' : `Línea ${line.description}`}
              </h3>
            </CardHeader>
          )}

          <CardBody>
            {line !== undefined ? <h5>Familias</h5> : undefined}
            <ReactTable
              excelName="Familias"
              defaultWidth={1000}
              indexRow={[0, 1, 4, 5]}
              widthRow={[120, 100, 150, 5]}
              columns={columns}
              data={families.map((family, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.LOGI_FAMILIES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setOpen(family)}
                          className="like"
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <Button justIcon round simple color="primary">
                        <Link to={`/admin/articulos/datos-maestros/familias/${family.id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                      <AllowedGuard permission={ConstantPermissions.LOGI_FAMILIES_DELETED}>
                        <ButtonDelete entity="logi/family" id={family.id} reload={loadFamilies} />
                      </AllowedGuard>
                    </div>
                  ),
                  code: family.code,
                  description: family.description,
                  line: family.logi_line_description,
                  state: family.state === 'A' ? 'Activo' : 'Inactivo',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
